export default "__VITE_ASSET__CZSATpM3__"